/* eslint-disable import/prefer-default-export */
export const NUMBER_OF_ROWS = 30;
export const DEFAULT_ROW_HEIGHT = 65;
export const DEFAULT_HEADER_HEIGHT = 56;
export const DEFAULT_FOOTER_HEIGHT = 69;
export const DEFAULT_ROW_MARGIN = 8;
export const ONBOARDING_ROW_MARGIN = 0;
export const MOBILE_ROW_HEIGHT = 45;
export const MOBILE_ROW_HEIGHT_COMPACT = 31;
export const MOBILE_HEADER_HEIGHT = 56;
export const MOBILE_HEADER_HEIGHT_COMPACT = 39;
export const BORDER_HEIGHT = 1;
export const ONBOARDING_DATA_GRID_CLASS_NAME = 'onboardingFingoDataGrid';
export const DEFAULT_DATA_GRID_CLASS_NAME = 'defaultFingoDataGrid';
export const DISABLED_ROW_CLASS_NAME = 'MuiDataGrid-row--disabled';

export const OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL = {
  sx: {
    overflowX: 'auto',
    // Prevenir que el scroll horizontal se propague al contenedor padre
    overscrollBehaviorX: 'contain',
    // Ocultar scrollbar pero mantener funcionalidad
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&': {
      scrollbarWidth: 'none', // Firefox
      msOverflowStyle: 'none', // IE/Edge
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto',
      overscrollBehaviorX: 'contain',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '&': {
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none', // IE/Edge
      },
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      minWidth: 'fit-content',
    },
  },
};
